/* import __COLOCATED_TEMPLATE__ from './invite-sending-denied.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();